<template>
  <v-card elevation="0" width="100%">
    <v-dialog v-model="dialog" max-width="500">
      <Confirm
          title="Salvar"
          message="Tem certeza de que deseja salvar estes dados?"
          buttonText="Salvar"
          @cancel="dialog = false"
          @action="submit"
      />
    </v-dialog>

    <v-form ref="tokenMelhorEnvio">
      <v-row class="ma-0">
        <v-col cols="12" sm="12" md="12" lg="12">
          <label class="ml-1 mb-2 label-details">Ainda não tem cadastro no melhor envio? <a target="_blank" :href="`${urlMelhorEnvio}p/BOaBxhfga1`">Cadastre-se aqui</a></label><br/>
          <label class="ml-1 mb-2 label-details">Token do melhor envio</label>
          <v-textarea
              style="border: 1px solid #979797; border-radius: 7.5px"
              color="black"
              background-color="#F5F5F5"
              outlined
              :rules="[rules.required]"
              hide-details
              required
              min-height="200"
              auto-grow
              v-model="currentUser.tokenMelhorEnvio"
          ></v-textarea>
        </v-col>
      </v-row>

      <v-row class="pb-3" justify="center">
        <v-col cols="12" md="6">
          <v-btn
              class="primary-button"
              color="normalred"
              elevation="0"
              @click="userMelhorEnvio()"
              block
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import Vue from "vue";
import Confirm from "../../components/ConfirmExit.vue";

export default {
  name: "TokenMelhorEnvio",
  components: {
    Confirm,
  },
  props: {},
  data: () => ({
    apiService: new ApiService(),
    dialog: false,
    currentUser: {},
    user: {},
    rules: {
      required: (value) => !!value || "Campo requerido.",
      maxValue: (v) => v <= 100 || "Maximo 100.",
    },
    userTypeMaster: 0,
    userTypeAdmin: 1,
    userTypeResale: 2,
    userTypeInstaller: 3,
    urlMelhorEnvio: process.env.VUE_APP_URL_MELHOR_ENVIO
  }),
  async created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    await this.updateUser();
  },
  methods: {
    async updateUser() {
      this.loading = true;

      let url;

      switch (this.user.type) {
        case 0:
          url = "user/get-one";
          break;
        case 1:
          url = "user/get-one";
          break;
        case 2:
          url = "resale/get-one";
          break;
        case 3:
          url = "installer/get-one";
          break;
      }

      await this.apiService.get(`${url}?id=${this.user.id}`).then((response) => {
        this.currentUser = response;
        this.loading = false;
      });
    },

    validate() {
      if (!this.$refs.tokenMelhorEnvio.validate()) {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "",
          message: "Digite o valor do frete padrão das revendas",
          trace: null,
        });
        return
      }
      this.dialog = true;
    },

    async userMelhorEnvio() {
      try {
        await this.apiService.post(`resale/usermelhorenvio`, this.currentUser)
            .then(async (response) => {
              await this.submit()
            })
            .catch((err) => {
              const {body} = err
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "error",
                title: "",
                message: body.message ? body.message : 'Verfique se o token esta correto e tente novamente',
                trace: null,
              });
            });
      } catch (e) {

      }
    },

    async submit() {
      try {
        let model = this.currentUser;
        await this.apiService.put(`resale/token-melhor-envio`, model)
            .then((resp) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: '',
                message: 'Token adicionado com sucesso!',
                trace: null,
              });

              this.dialog = false;
              this.loading = false;
            })
            .catch((err) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "error",
                title: "Erro ao cadastrar produto",
                message: err.body.message,
                trace: null,
              });

              this.dialog = false;
              this.loading = false;
            });
        await this.updateUser();
      } catch (e) {

      }
    },
  },
};
</script>
<style scoped>
</style>
